import React, { useEffect, useState } from "react";
import { Button, IconButton, Card, FormLabel, Grid, TextField, Typography, Divider, Select, ThemeProvider, InputLabel, createTheme, FormControl, MenuItem, Tooltip, makeStyles } from '@material-ui/core';

import CustomUnicefTextField from '../../components/controls/CustomUnicefTextField';
import CustomizedSnackbars from '../../components/controls/CustomSnackBar';
import Modals from "../../components/modal";

import PersonAddIcon from "@material-ui/icons/PersonAdd";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import PregnantWomanIcon from "@material-ui/icons/PregnantWoman";
import WcIcon from "@material-ui/icons/Wc";
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';

/* =========================
   API
=========================*/
import {
    getOrgForDashboard,
    getTownshipForDashboard,
    getClinicForDashboard,
    getIndi1,
    getIndi2,
    getIndi3,
    getIndi4,
    getIndi5,
    getIndi6,
    getIndi7,
    getIndi8,
    getIndi9,
    getIndi10,
    getIndi11,
    getIndi12,
    getIndi13,
    getIndi14,
    getIndi15,
    getIndi16,
    getIndi17
} from "../../modals/dashboarddata"
import * as login from "../../modals/login";

const baseDashboardData = [
    { name: "Registered patients", value: 0, group: "Registration" },
    { name: "Clinics", value: 0, group: "PHC" },
    { name: "Visits", value: 0, group: "PHC" },
    {
        name: "Top Diseases",
        group: "PHC",
        value: [],
    },
    { name: "Consultations", value: 0, group: "MNCH" },
    { name: "Deliveries", value: 0, group: "MNCH" },
    { name: "ANC1", value: 0, group: "MNCH" },
    { name: "ANC4+", value: 0, group: "MNCH" },
    { name: "PNC 2d", value: 0, group: "MNCH" },
    { name: "PNC 42d", value: 0, group: "MNCH" },
    { name: "Newborn care", value: 0, group: "MNCH" },
    { name: "FP services", value: 0, group: "SRHR" },
    { name: "RH services", value: 0, group: "SRHR" },
    { name: "FP visits", value: 0, group: "SRHR" },
    { name: "Contraceptives", value: 0, group: "SRHR" },
    { name: "PAC", value: 0, group: "SRHR" },
    { name: "GBV", value: 0, group: "SRHR" },
];

const indicatorTooltips = {
    "Registered patients": "Number of paitents who registered in this reporting periods",
    "Clinics": "Number of clinics/facilities that provided health services",
    "Visits": "Number of patient visits/consultations",
    "Consultations": "Number of consultations related to MNCH and SRHR",
    "Top Diseases": "Top 10 disease from general health services",
    "Deliveries": "Number of Delivery (still birth + live birth) in this reporting periods",
    "FP services": "Number of women who received FP services in this reporting periods",
    "RH services": "Number of women who received Reproductive Health Care services in this reporting periods",
    "ANC1": "Number of pregnant women in the programme areas who received at least one antenatal care",
    "ANC4+": "Number and proportion of pregnant women in the programme areas who received four or more antenatal care",
    "PNC 2d": "Number of women who received at least one PNC provided by skilled providers within 2 days",
    "PNC 42d": "Total number of women received at least one PNC within 42 days after delivery",
    "Newborn care": "Number and percentage of newborns who received newborn care within two days after birth",
    "FP visits": "Number of women received family planning service",
    "Contraceptives": "Number of couples with female partner aged 15-49 currently using modern contraceptives",
    "PAC": "Number of Post Abortion Care services delivered during reporting period",
    "GBV": "Number of survivors of Gender-Based Violence (GBV) supported to receive case management services",
};

const toNumberFromRow = (row) => {
    if (!row || typeof row !== "object") {
        return 0;
    }

    const values = Object.values(row);
    for (const value of values) {
        const num = Number(value);
        if (!Number.isNaN(num)) {
            return num;
        }
    }

    return 0;
}

const getResponseRows = (response, key) => {
    return response?.data?.data?.[key] || [];
}

/* =========================
   Styles
=========================*/
const useStyles = makeStyles((theme) => ({
    root: {
        "& > *": {
            flexGrow: 1
        },
    },
    "& .MuiFilledInput-root": {
        backgroundColor: "#F5F8FC"
    },
    fontSize: {
        "& span:last-child": {
            fontSize: 13
        }
    },
    cardStyle: {
        marginTop: theme.spacing(0.9),
        marginBottom: theme.spacing(1),
    },
    cardStyleTwo: {
        width: "100%",
        marginLeft: theme.spacing(1),
        marginTop: theme.spacing(0.9),
        borderRadius: "3px"
    },
    selected: {
        backgroundColor: "#EAF2FB !important",
        color: '#123B68'
    },
    table: {
        width: '98vw',
        maxWidth: '98vw',
        borderCollapse: 'collapse',
        margin: 'auto',
        marginTop: '10px'
    },
    indicatorTitle: {
        width: 280,
        maxWidth: 280,
        height: 60,
        background: '#123B68',
        color: '#F7FAFC',
        border: '0.5px solid lightgray',
        borderRadius: '5px 0px 0px 0px'
    },
    title1: {
        width: 1,
        maxWidth: 1,
        background: '#123B68',
        color: '#F7FAFC',
        fontSize: '9px',
        border: '0.5px solid lightgray'
    },
    titleTotal1: {
        width: 1,
        maxWidth: 1,
        background: '#123B68',
        color: '#F7FAFC',
        fontSize: '9px',
        border: '0.5px solid lightgray',
        borderRadius: '0px 5px 0px 0px'
    },
    title2: {
        width: 0.5,
        maxWidth: 0.5,
        background: '#123B68',
        color: '#F7FAFC',
        fontSize: '8px',
        border: '0.5px solid lightgray'
    },
    indicatorName: {
        width: 220,
        maxWidth: 220,
        fontSize: '11px',
        background: '#F4F7FB',
        color: '#1F2A37',
        border: '0.5px solid #D5DFEB',
        fontWeight: 'lightBold'
    },
    newOldTitle: {
        width: 5,
        maxWidth: 5,
        fontSize: '8px',
        background: '#F4F7FB',
        color: '#1F2A37',
        border: '0.5px solid #D5DFEB'
    },
    newOldData: {
        width: 1,
        maxWidth: 1,
        background: '#F4F7FB',
        color: '#1F2A37',
        fontSize: '8px',
        border: '0.5px solid #D5DFEB'
    }
}));

const radioTheme = createTheme({
    palette: {
        primary: {
            main: "#123B68"
        },
        secondary: {
            main: "#ffff"
        }
    }
});


/* =========================
   COUNT UP
=========================*/
function useCountUp(end, duration = 800) {
    const [value, setValue] = useState(0);

    useEffect(() => {
        let start = 0;
        const increment = end / (duration / 16);

        const timer = setInterval(() => {
            start += increment;

            if (start >= end) {
                setValue(end);
                clearInterval(timer);
            } else {
                setValue(Math.floor(start));
            }
        }, 16);

        return () => clearInterval(timer);
    }, [end, duration]);

    return value;
}

/* =========================
   APP
=========================*/
export default function EntryHomePageDashboard(props) {

    const classes = useStyles();

    const [dashboardData, setDashboardData] = useState(baseDashboardData)

    const color = {
        Registration: "#2E7D5B",
        PHC: "#123B68",
        MNCH: "#5B4DB7",
        SRHR: "#2B6CB0",
    };

    const icons = {
        Registration: <PersonAddIcon style={{ fontSize: 16 }} />,
        PHC: <LocalHospitalIcon style={{ fontSize: 16 }} />,
        MNCH: <PregnantWomanIcon style={{ fontSize: 16 }} />,
        SRHR: <WcIcon style={{ fontSize: 16 }} />,
    };

    const [orgData, setOrgData] = useState([])
    const [projectData, setProjectData] = useState([])
    const [tspData, setTspData] = useState([])
    const [clinicData, setClinicData] = useState([])
    const [tspSelect, setTspSelect] = useState([])
    const [clinicSelect, setClinicSelect] = useState([])
    const [orgSelect, setOrgSelect] = useState([])
    const [projectSelect, setProjectSelect] = useState([])
    const [yearSelect, setYearSelect] = useState("")
    const [quarterSelect, setQuarterSelect] = useState("")
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const isCpi99Org = sessionStorage.getItem('org') === 'CPI-99'
    const isP060Project = sessionStorage.getItem('project') === 'P-060'
    const showOrgProjectFilters = isCpi99Org || isP060Project

    const [error, setError] = useState("")
    const [success, setSuccess] = useState("")
    const [successSnack, setSuccessSnack] = useState(false)
    const [openSnack, setOpenSnack] = useState(false)
    const [loading, setLoading] = useState(false)

    const setSuccessSnackBarOpen = () => {
        setSuccessSnack(true)
    }

    const setSuccessSnackBarClose = () => {
        setSuccessSnack(false)
    }

    const setSnackBarOpen = () => {
        setOpenSnack(true)
    }

    const setSnackBarClose = () => {
        setOpenSnack(false)
    }

    const townshipLabelById = (id) => {
        const selected = tspData.find((item) => `${item.TSP_ID}` === `${id}`)
        return selected ? selected.TSP_NAME : id
    }

    const clinicLabelById = (id) => {
        const selected = clinicData.find((item) => `${item.CLN_ID}` === `${id}`)
        return selected ? selected.CLN_NAME : id
    }

    const orgLabelById = (id) => {
        const selected = orgData.find((item) => `${item.ORG_ID}` === `${id}`)
        return selected ? selected.ORG_SHORTNAME : id
    }

    const projectLabelById = (id) => {
        const selected = projectData.find((item) => `${item.PROJECT_ID}` === `${id}`)
        return selected ? selected.PROJECT_NAME : id
    }

    const getQuarterDateRange = (year, quarter) => {
        const y = Number(year);

        switch (quarter) {
            case "Q1": {
                setStartDate(`16-DEC-${y - 1}`);
                setEndDate(`15-MAR-${y}`);
                break;
            }

            case "Q2": {
                setStartDate(`16-MAR-${y}`);
                setEndDate(`15-JUN-${y}`);
                break;
            }

            case "Q3": {
                setStartDate(`16-JUN-${y}`);
                setEndDate(`15-SEP-${y}`);
                break;
            }

            case "Q4": {
                setStartDate(`16-SEP-${y}`);
                setEndDate(`15-DEC-${y}`);
                break;
            }

            default: {
                setStartDate(null);
                setEndDate(null);
                break;
            }
        }
    };

    const tspSelectHandle = async (event) => {
        const value = typeof event.target.value === "string"
            ? event.target.value.split(",")
            : event.target.value

        setTspSelect(value)
        setClinicSelect([])

        if (!value.length) {
            setClinicData([])
            return
        }

        const payload = {
            parameter: {
                projID: sessionStorage.getItem('project'),
                orgID: sessionStorage.getItem('org')
            },
            select: value,
            orgSelect,
            projectSelect
        }

        const clinic = await getClinicForDashboard(payload)
        setClinicData(clinic?.data?.data?.getClinicForDashboard || [])
    }

    const clinicSelectHandle = (event) => {
        const value = typeof event.target.value === "string"
            ? event.target.value.split(",")
            : event.target.value

        setClinicSelect(value)
    }

    const orgSelectHandle = (event) => {
        const value = typeof event.target.value === "string"
            ? event.target.value.split(",")
            : event.target.value

        setOrgSelect(value)
        setTspSelect([])
        setClinicSelect([])
        setClinicData([])
    }

    const projectSelectHandle = (event) => {
        const value = typeof event.target.value === "string"
            ? event.target.value.split(",")
            : event.target.value

        setProjectSelect(value)
        setTspSelect([])
        setClinicSelect([])
        setClinicData([])
    }

    useEffect(() => {
        const loadTownships = async () => {
            if (showOrgProjectFilters && (!orgSelect.length || !projectSelect.length)) {
                setTspData([])
                return
            }

            const township = await getTownshipForDashboard({ orgSelect, projectSelect })
            setTspData(township?.data?.data?.getTownshipForDashboard || [])
        }

        loadTownships()
    }, [orgSelect, projectSelect, showOrgProjectFilters])

    const checkBtn = async () => {
        if (!tspSelect.length || !yearSelect || !quarterSelect || (isCpi99Org && (!orgSelect.length || !projectSelect.length))) {
            setError("Please select all required fields")
            setSnackBarOpen()
            return
        }
        setLoading(true)
        try {
            const payload = {
                parameter: {
                    projID: sessionStorage.getItem('project'),
                    orgID: sessionStorage.getItem('org'),
                    year: yearSelect,
                    quarter: quarterSelect,
                    startDate: startDate,
                    endDate: endDate
                },
                tspSelect: tspSelect,
                clnSelect: clinicSelect
            }

            const [indi1, indi2, indi3, indi4, indi5, indi6, indi7, indi8, indi9, indi10, indi11, indi12, indi13, indi14, indi15, indi16, indi17] = await Promise.all([
                getIndi1(payload),
                getIndi2(payload),
                getIndi3(payload),
                getIndi4(payload),
                getIndi5(payload),
                getIndi6(payload),
                getIndi7(payload),
                getIndi8(payload),
                getIndi9(payload),
                getIndi10(payload),
                getIndi11(payload),
                getIndi12(payload),
                getIndi13(payload),
                getIndi14(payload),
                getIndi15(payload),
                getIndi16(payload),
                getIndi17(payload)
            ])

            const indicatorValues = {
                "Registered patients": toNumberFromRow(getResponseRows(indi1, 'getIndi1')[0]),
                "Clinics": toNumberFromRow(getResponseRows(indi2, 'getIndi2')[0]),
                "Visits": toNumberFromRow(getResponseRows(indi3, 'getIndi3')[0]),
                "Consultations": toNumberFromRow(getResponseRows(indi4, 'getIndi4')[0]),
                "Deliveries": toNumberFromRow(getResponseRows(indi6, 'getIndi6')[0]),
                "FP services": toNumberFromRow(getResponseRows(indi7, 'getIndi7')[0]),
                "RH services": toNumberFromRow(getResponseRows(indi8, 'getIndi8')[0]),
                "ANC1": toNumberFromRow(getResponseRows(indi9, 'getIndi9')[0]),
                "ANC4+": toNumberFromRow(getResponseRows(indi10, 'getIndi10')[0]),
                "PNC 2d": toNumberFromRow(getResponseRows(indi11, 'getIndi11')[0]),
                "PNC 42d": toNumberFromRow(getResponseRows(indi12, 'getIndi12')[0]),
                "Newborn care": toNumberFromRow(getResponseRows(indi13, 'getIndi13')[0]),
                "FP visits": toNumberFromRow(getResponseRows(indi14, 'getIndi14')[0]),
                "Contraceptives": toNumberFromRow(getResponseRows(indi15, 'getIndi15')[0]),
                "PAC": toNumberFromRow(getResponseRows(indi16, 'getIndi16')[0]),
                "GBV": toNumberFromRow(getResponseRows(indi17, 'getIndi17')[0]),
            }

            const indi5Rows = getResponseRows(indi5, 'getIndi5')
            const topDiseaseData = indi5Rows.map((item) => ({
                name: item.DISEASENAME || item.DiseaseName || "Unknown",
                count: Number(item.TOTALCOUNT || item.TotalCount || 0)
            }))

            const nextDashboardData = baseDashboardData.map((item) => {
                if (item.name === "Top Diseases") {
                    return {
                        ...item,
                        value: topDiseaseData
                    }
                }

                if (Object.prototype.hasOwnProperty.call(indicatorValues, item.name)) {
                    return {
                        ...item,
                        value: indicatorValues[item.name]
                    }
                }

                return item
            })

            setDashboardData(nextDashboardData)
            console.log('Dashboard data updated:', nextDashboardData);
            setSuccess("Indicator 1 to 12 data loaded successfully")
            setSuccessSnackBarOpen()
        } catch (e) {
            setError("Failed to load indicator data")
            setSnackBarOpen()
        } finally {
            setLoading(false)
        }
    }

    const clearBtn = () => {
        setYearSelect("")
        setQuarterSelect("")
        setTspSelect([])
        setClinicSelect([])
        setOrgSelect([])
        setProjectSelect([])
        setClinicData([])
    }

    useEffect(() => {
        const fn = async () => {
            setLoading(true)
            try {
                if (!showOrgProjectFilters) {
                    const township = await getTownshipForDashboard()
                    setTspData(township?.data?.data?.getTownshipForDashboard || [])
                }

                if (showOrgProjectFilters) {
                    const [projectResponse, orgResponse] = await Promise.all([
                        login.login(),
                        getOrgForDashboard()
                    ])
                    setProjectData(projectResponse?.data?.data?.getAllProjectInLogIn || [])
                    setOrgData(orgResponse?.data?.data?.getOrgForDashboard || [])
                }
            } finally {
                setLoading(false)
            }
        }
        fn();
    }, [])

    return (
        <div style={page}>
            <Modals open={loading} />
            {successSnack && <CustomizedSnackbars open={setSuccessSnackBarOpen} close={setSuccessSnackBarClose} alertMsg={success} type="success" />}
            {openSnack && <CustomizedSnackbars open={setSnackBarOpen} close={setSnackBarClose} alertMsg={error} type="warning" />}
            <Grid
                container
                spacing={2}
                alignItems="center"
                style={{ marginTop: 10 }}
                justifyContent="flex-start"
            >
                <Grid item xs={12} sm={6} md={2}>
                    <FormControl
                        variant="filled"
                        size="small"
                        style={{
                            width: "100%",
                            background: "#fff",
                            borderRadius: 10,
                            border: "1px solid #D7E0D9",
                        }}>
                        <InputLabel id="demo-simple-select-filled-label">{<Grid row container><Typography color="#475569">Year</Typography>
                            <Typography variant='subtitle2' style={{ color: '#2B6CB0' }}>*</Typography></Grid>}</InputLabel>
                        <Select
                            disableUnderline
                            style={{
                                background: "#fff",
                                borderRadius: 10,
                            }}
                            value={yearSelect}
                            onChange={(e) => setYearSelect(e.target.value)}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left",
                                },
                                style: {
                                    maxHeight: 400,
                                },
                                getContentAnchorEl: null
                            }}>
                            <MenuItem value={new Date().getFullYear()} classes={{ selected: classes.selected }}>{new Date().getFullYear()}</MenuItem>
                            <MenuItem value={new Date().getFullYear() - 1} classes={{ selected: classes.selected }}>{new Date().getFullYear() - 1}</MenuItem>
                            <MenuItem value={new Date().getFullYear() - 2} classes={{ selected: classes.selected }}>{new Date().getFullYear() - 2}</MenuItem>
                            <MenuItem value={new Date().getFullYear() - 3} classes={{ selected: classes.selected }}>{new Date().getFullYear() - 3}</MenuItem>
                            <MenuItem value={new Date().getFullYear() - 4} classes={{ selected: classes.selected }}>{new Date().getFullYear() - 4}</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <FormControl
                        variant="filled"
                        size="small"
                        style={{
                            width: "100%",
                            background: "#fff",
                            borderRadius: 10,
                            border: "1px solid #D7E0D9",
                        }}>
                        <InputLabel id="demo-simple-select-filled-label">{<Grid row container><Typography color="#475569">Quarter</Typography>
                            <Typography variant='subtitle2' style={{ color: '#2B6CB0' }}>*</Typography></Grid>}</InputLabel>
                        <Select
                            disableUnderline
                            style={{
                                background: "#fff",
                                borderRadius: 10,
                            }}
                            disabled={!yearSelect}
                            value={quarterSelect}
                            onChange={(e) => { setQuarterSelect(e.target.value); getQuarterDateRange(yearSelect, e.target.value); }}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left",
                                },
                                style: {
                                    maxHeight: 400,
                                },
                                getContentAnchorEl: null
                            }}>
                            <MenuItem value={'Q1'} classes={{ selected: classes.selected }}>Q1</MenuItem>
                            <MenuItem value={'Q2'} classes={{ selected: classes.selected }}>Q2</MenuItem>
                            <MenuItem value={'Q3'} classes={{ selected: classes.selected }}>Q3</MenuItem>
                            <MenuItem value={'Q4'} classes={{ selected: classes.selected }}>Q4</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                {showOrgProjectFilters && (
                    <Grid item xs={12} sm={6} md={2}>
                        <ThemeProvider theme={radioTheme}>
                            <FormControl
                                variant="filled"
                                size="small"
                                style={{
                                    width: "100%",
                                    background: "#fff",
                                    borderRadius: 10,
                                    border: "1px solid #D7E0D9",
                                }}>
                                <InputLabel id="org-select-label"><Grid row container><Typography color="#475569">Organization</Typography>{isCpi99Org && <Typography variant='subtitle2' style={{ color: '#2B6CB0' }}>*</Typography>}</Grid></InputLabel>
                                <Select
                                    labelId="org-select-label"
                                    disableUnderline
                                    style={{
                                        background: "#fff",
                                        borderRadius: 10,
                                    }}
                                    multiple
                                    renderValue={(selected) => (
                                        <span style={selectedValue}>
                                            {selected.map((id) => orgLabelById(id)).join(', ')}
                                        </span>
                                    )}
                                    value={orgSelect}
                                    onChange={orgSelectHandle}
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "left",
                                        },
                                        style: {
                                            maxHeight: 400,
                                        },
                                        getContentAnchorEl: null
                                    }}>
                                    {orgData.map((option) => (
                                        <MenuItem value={option.ORG_ID} key={option.ORG_ID} classes={{ selected: classes.selected }}>
                                            {option.ORG_SHORTNAME}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </ThemeProvider>
                    </Grid>
                )}
                {showOrgProjectFilters && (
                    <Grid item xs={12} sm={6} md={2}>
                        <ThemeProvider theme={radioTheme}>
                            <FormControl
                                variant="filled"
                                size="small"
                                style={{
                                    width: "100%",
                                    background: "#fff",
                                    borderRadius: 10,
                                    border: "1px solid #D7E0D9",
                                }}>
                                <InputLabel id="project-select-label"><Grid row container><Typography color="#475569">Project</Typography>{isCpi99Org && <Typography variant='subtitle2' style={{ color: '#2B6CB0' }}>*</Typography>}</Grid></InputLabel>
                                <Select
                                    labelId="project-select-label"
                                    disableUnderline
                                    style={{
                                        background: "#fff",
                                        borderRadius: 10,
                                    }}
                                    multiple
                                    renderValue={(selected) => (
                                        <span style={selectedValue}>
                                            {selected.map((id) => projectLabelById(id)).join(', ')}
                                        </span>
                                    )}
                                    value={projectSelect}
                                    onChange={projectSelectHandle}
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "left",
                                        },
                                        style: {
                                            maxHeight: 400,
                                        },
                                        getContentAnchorEl: null
                                    }}>
                                    {projectData.map((option) => (
                                        <MenuItem value={option.PROJECT_ID} key={option.PROJECT_ID} classes={{ selected: classes.selected }}>
                                            {option.PROJECT_NAME}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </ThemeProvider>
                    </Grid>
                )}
                <Grid item xs={12} sm={6} md={3}>
                    <ThemeProvider theme={radioTheme}>
                        <FormControl
                            variant="filled"
                            size="small"
                            style={{
                                width: "100%",
                                background: "#fff",
                                borderRadius: 10,
                                border: "1px solid #D7E0D9",
                            }}>
                            <InputLabel id="demo-simple-select-filled-label">{<Grid row container><Typography color="#475569">Township</Typography>
                                <Typography variant='subtitle2' style={{ color: '#2B6CB0' }}>*</Typography></Grid>}</InputLabel>
                            <Select
                                disableUnderline
                                style={{
                                    background: "#fff",
                                    borderRadius: 10,
                                }}
                                multiple
                                renderValue={(selected) => selected.map((id) => townshipLabelById(id)).join(', ')}
                                value={tspSelect}
                                onChange={tspSelectHandle}
                                disabled={showOrgProjectFilters && (!orgSelect.length || !projectSelect.length)}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left",
                                    },
                                    style: {
                                        maxHeight: 400,
                                    },
                                    getContentAnchorEl: null
                                }}>

                                {tspData.length && tspData.map((option) => (
                                    <MenuItem value={option.TSP_ID} key={option.TSP_ID} classes={{ selected: classes.selected }}>
                                        {option.TSP_NAME}
                                    </MenuItem>
                                ))}

                            </Select>
                        </FormControl>
                    </ThemeProvider>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <ThemeProvider theme={radioTheme}>
                        <FormControl
                            variant="filled"
                            size="small"
                            style={{
                                width: "100%",
                                background: "#fff",
                                borderRadius: 10,
                                border: "1px solid #D7E0D9",
                            }}>
                            <InputLabel id="demo-simple-select-filled-label">{<Grid row container><Typography color="#475569">Clinic</Typography></Grid>}</InputLabel>
                            <Select
                                disableUnderline
                                style={{
                                    background: "#fff",
                                    borderRadius: 10,
                                }}

                                multiple
                                renderValue={(selected) => selected.map((id) => clinicLabelById(id)).join(', ')}
                                value={clinicSelect}
                                onChange={clinicSelectHandle}
                                disabled={!tspSelect.length}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left",
                                    },
                                    style: {
                                        maxHeight: 400,
                                    },
                                    getContentAnchorEl: null
                                }}>

                                {clinicData.length && clinicData.map((option) => (
                                    <MenuItem value={option.CLN_ID} key={option.CLN_ID} classes={{ selected: classes.selected }}>
                                        {option.CLN_NAME}
                                    </MenuItem>
                                ))}

                            </Select>
                        </FormControl>
                    </ThemeProvider>
                </Grid>
                <Grid item xs={12} sm={6} md={2}
                    style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <Tooltip title="Load dashboard data">
                        <IconButton
                            aria-label="Load dashboard data"
                            onClick={checkBtn}
                            style={{
                                width: 44,
                                height: 44,
                                borderRadius: 12,
                                background: "linear-gradient(135deg, #123B68 0%, #2B6CB0 100%)",
                                color: "#fff",
                                boxShadow: "0 4px 10px rgba(18,59,104,0.22)",
                            }}
                        >
                            <CheckIcon style={{ fontSize: 20 }} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Clear filters">
                        <IconButton
                            aria-label="Clear filters"
                            onClick={clearBtn}
                            style={{
                                width: 44,
                                height: 44,
                                borderRadius: 12,
                                background: "#fff",
                                color: "#475569",
                                border: "1px solid #D5DFEB",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                            }}
                        >
                            <ClearIcon style={{ fontSize: 20 }} />
                        </IconButton>
                    </Tooltip>
                </Grid>


            </Grid>
            <Grid container spacing={2} style={{ marginTop: 20 }}>
                <Grid item xs={12} md={6}>
                    {/* Registration */}
                    <Section
                        title="Registration"
                        color={color.Registration}
                        icon={icons.Registration}
                    >
                        <KPI label="Registered" tooltip={indicatorTooltips["Registered patients"]} value={dashboardData.find((d) => d.name === "Registered patients")?.value || 0} color={color.Registration} />
                    </Section>

                    <div style={{ height: 20 }} />

                    {/* MNCH */}
                    <Section title="MNCH" color={color.MNCH} icon={icons.MNCH}>
                        <div style={gridAuto}>
                            {dashboardData
                                .filter((d) => d.group === "MNCH")
                                .map((item, idx) => (
                                    <KPI
                                        key={idx}
                                        label={item.name}
                                        tooltip={indicatorTooltips[item.name]}
                                        value={item.value}
                                        color={color.MNCH}
                                    />
                                ))}
                        </div>


                    </Section>
                    <div style={{ height: 20 }} />
                    <Section title="PHC" color={color.PHC} icon={icons.PHC}>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                            <KPI label="Clinics" tooltip={indicatorTooltips.Clinics} value={dashboardData.find((d) => d.name === "Clinics")?.value || 0} color={color.PHC} />

                            <KPI label="Visits" tooltip={indicatorTooltips.Visits} value={dashboardData.find((d) => d.name === "Visits")?.value || 0} color={color.PHC} />
                        </div>
                    </Section>
                </Grid>

                {/* RIGHT COLUMN */}
                <Grid item xs={12} md={6}>
                    {/* SRHR */}
                    <Section title="SRHR" color={color.SRHR} icon={icons.SRHR}>
                        <div style={gridAuto}>
                            {dashboardData
                                .filter((d) => d.group === "SRHR")
                                .map((item, idx) => (
                                    <KPI
                                        key={idx}
                                        label={item.name}
                                        tooltip={indicatorTooltips[item.name]}
                                        value={item.value}
                                        color={color.SRHR}
                                    />
                                ))}
                        </div>
                    </Section>

                    <div style={{ height: 20 }} />

                    {/* PHC */}
                    <Section title="Top Diseases" tooltip={indicatorTooltips["Top Diseases"]} color={color.PHC} icon={icons.PHC}>
                        <div style={{ marginTop: 2 }}>
                            <DiseaseBar
                                data={dashboardData.find((d) => d.name === "Top Diseases")?.value || []}
                                color={color.PHC}
                            />
                        </div>
                    </Section>
                </Grid>
            </Grid>
        </div>
    );
}

/* =========================
   SECTION
=========================*/
function Section({ title, tooltip, color, icon, children }) {
    return (
        <div style={card}>
            <div style={header(color)}>
                {icon}
                <Tooltip title={tooltip || title} placement="top" arrow>
                    <span>{title}</span>
                </Tooltip>
            </div>

            <div style={{ padding: 10 }}>{children}</div>
        </div>
    );
}

/* =========================
   KPI
=========================*/
function KPI({ label, tooltip, value, color }) {
    const count = useCountUp(value);

    return (
        <div style={kpi(color)}>
            <Tooltip title={tooltip || label} placement="top" arrow>
                <div style={kpiLabel}>{label}</div>
            </Tooltip>

            <b style={{ fontSize: 18, color }}>{count}</b>
        </div>
    );
}

/* =========================
   DISEASE BAR
=========================*/
function DiseaseBar({ data, color }) {
    if (!data.length) {
        return (
            <div style={diseaseWrap}>
                <div style={diseaseTitle}>Diseases</div>
                <div style={{ fontSize: 11, color: "#64748B" }}>
                    No disease data available
                </div>
            </div>
        );
    }

    const max = Math.max(...data.map((d) => d.count));

    return (
        <div style={diseaseWrap}>
            <div style={diseaseTitle}>Diseases</div>
            {data.map((d, i) => (
                <div key={i} style={{ marginBottom: 8 }}>
                    <div style={barHead}>
                        <span>{d.name}</span>
                        <b>{d.count}</b>
                    </div>

                    <div style={barBg}>
                        <div
                            style={{
                                width: `${(d.count / max) * 100}%`,
                                height: "100%",
                                background: color,
                                borderRadius: 10,
                                transition: "0.5s",
                            }}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
}

/* =========================
   STYLES
=========================*/

const selectedValue = {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
};

const summaryCard = {
    background: "#FBFAF7",
    borderRadius: 10,
    padding: "10px 12px",
    boxShadow: "0 2px 6px rgba(15,118,110,0.06)",
};

const summaryTop = {
    display: "flex",
    alignItems: "center",
    gap: 8,
};

const summaryTitle = {
    fontSize: 10,
    color: "#64748B",
    marginBottom: 2,
};

const summaryValue = {
    fontSize: 18,
    fontWeight: 700,
};

const page = {
    padding: 10,
    /* background: "linear-gradient(180deg, #F7FAFE 0%, #EEF3F8 100%)",
    minHeight: "100vh", */
    
};

const card = {
    background: "#fff",
    borderRadius: 14,
    overflow: "hidden",
    boxShadow: "0 8px 24px rgba(18,59,104,0.08)",
};

const header = (color) => ({
    background: color,
    color: "#fff",
    padding: "8px 10px",
    fontSize: 13,
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    gap: 6,
});

const gridAuto = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(110px, 1fr))",
    gap: 8,
};

const kpi = (color) => ({
    background: "#fff",
    border: `1px solid ${color}20`,
    borderLeft: `3px solid ${color}`,
    borderRadius: 10,
    padding: "8px 10px",
    minHeight: 30,

    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
});

const kpiLabel = {
    fontSize: 10,
    color: "#5B677A",
};

const diseaseWrap = {
    background: "#F8FBFF",
    borderRadius: 10,
    padding: 10,
};

const diseaseTitle = {
    fontSize: 18,
    fontWeight: 700,
    marginBottom: 10,
    color: "#123B68",
};

const barHead = {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 18,
    fontWeight : 500,
    marginBottom: 3,
    color: "#334155",
};

const barBg = {
    height: 6,
    background: "#D7E4F2",
    borderRadius: 10,
    overflow: "hidden",
};
